import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import {DateTime} from 'luxon';
import {TodayCalendarHeaderComponent} from '../today-calendar-header/today-calendar-header.component';

@Component({
  selector: 'app-date-range-picker-v2',
  templateUrl: './date-range-picker-v2.component.html',
  styleUrls: ['./date-range-picker-v2.component.scss'],
  standalone: false,
})
export class DateRangePickerV2Component implements OnChanges {
  @Input() start: DateTime | null = null;
  @Input() end: DateTime | null = null;
  @Input() startPlaceholder = 'Start';
  @Input() endPlaceholder = 'End';
  @Input() min: DateTime | null = null;
  @Input() max: DateTime | null = null;

  @Output() startChange = new EventEmitter<DateTime | null>();
  @Output() endChange = new EventEmitter<DateTime | null>();

  internalStart: DateTime | null = null;
  internalEnd: DateTime | null = null;

  readonly calendarHeader = TodayCalendarHeaderComponent;

  get hasValue(): boolean {
    return !!this.internalStart || !!this.internalEnd;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.start) this.internalStart = this.start;
    if (changes.end) this.internalEnd = this.end;
  }

  onStartChange(event: MatDatepickerInputEvent<DateTime>): void {
    this.internalStart = event.value;
    this.startChange.emit(event.value);
  }

  onEndChange(event: MatDatepickerInputEvent<DateTime>): void {
    this.internalEnd = event.value;
    this.endChange.emit(event.value);
  }

  clear(): void {
    this.internalStart = null;
    this.internalEnd = null;
    this.startChange.emit(null);
    this.endChange.emit(null);
  }
}
